import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AsyncJob, AsyncJobsState } from './asyncJobsTypes';
import type { RootState } from '../../store';

const initialState: AsyncJobsState = {};

const asyncJobsSlice = createSlice({
  name: 'asyncJobs',
  initialState,
  reducers: {
    setAsyncJob: (state, action: PayloadAction<AsyncJob>) => {
      state[action.payload.id] = action.payload;
    },
    
    removeAsyncJob: (state, action: PayloadAction<number>) => {
      delete state[action.payload];
    },
    
    clearAsyncJobs: (state) => {
      Object.keys(state).forEach(key => delete state[key as keyof AsyncJobsState]);
    },
    
    setAsyncJobs: (state, action: PayloadAction<AsyncJob[]>) => {
      action.payload.forEach(job => {
        state[job.id] = job;
      });
    },
  },
});

export const { setAsyncJob, removeAsyncJob, clearAsyncJobs, setAsyncJobs } = asyncJobsSlice.actions;
export default asyncJobsSlice.reducer;

export const selectAllAsyncJobs = (state: RootState): AsyncJobsState => state.asyncJobs;

export const selectAsyncJobById = (state: RootState, jobId: number): AsyncJob | null => 
  state.asyncJobs[jobId] ?? null;

export const selectActiveJobs = (state: RootState): AsyncJob[] =>
  Object.values(state.asyncJobs).filter(
    job => job.status === 'pending' || job.status === 'running'
  );

export const selectCompletedJobs = (state: RootState): AsyncJob[] =>
  Object.values(state.asyncJobs).filter(
    job => job.status === 'completed' || job.status === 'failed'
  );

export const selectActiveCopyJobForNewProject = (
  state: RootState, 
  projectId: number
): AsyncJob | null =>
  Object.values(state.asyncJobs).find(
    job => 
      job.kind === 'project_copy' &&
      job.project === projectId &&
      (job.status === 'pending' || job.status === 'running')
  ) ?? null;
